import { find, get } from "lodash";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import { requestContentPages } from "~/store/resource/resourceAction";
import { Delpath } from "~/utils/constants";
import { NonUpBeta } from "~/utils/func";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ProcedurePageMobile = Loadable({
  loader: () => import("~/components/mobile/pages/Procedure"),
  loading: LoadableLoading
});
const ProcedurePageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Procedure"),
  loading: LoadableLoading
});
const ProcedurePageMobileTest = Loadable({
  loader: () => import("~/components/mobile/pages/ProcedureTest"),
  loading: LoadableLoading
});
const ProcedurePageDesktopTest = Loadable({
  loader: () => import("~/components/desktop/pages/ProcedureTest"),
  loading: LoadableLoading
});
class Procedure extends Component {
  componentDidMount() {
    if (NonUpBeta()) {
      const pathName = Delpath(this.props.location.pathname);
      this.props.requestContentPages(pathName);
    }
  }

  render() {
    const info = get(partnerInfo, "menu");
    const procedureInfo = find(info, { key: "quy-trinh" });
    const { device } = this.props;
    return (
      <React.Fragment>
        {NonUpBeta() ? (
          device === "mobile" ? (
            <ProcedurePageMobileTest
              procedureInfo={procedureInfo}
              {...this.props}
            />
          ) : (
            <ProcedurePageDesktopTest
              procedureInfo={procedureInfo}
              {...this.props}
            />
          )
        ) : device === "mobile" ? (
          <ProcedurePageMobile procedureInfo={procedureInfo} />
        ) : (
          <ProcedurePageDesktop procedureInfo={procedureInfo} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    resource: { ContentPages }
  } = state;
  return {
    device: type,
    ContentPages
  };
};
const mapDispatchToProps = dispatch => {
  return {
    requestContentPages: pathName => dispatch(requestContentPages(pathName)) // có
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Procedure);
